import type { AppDetail, Environment } from '@/lib/types';

/**
 * Which platforms can actually be sent to in this environment. The workers treat missing or disabled credentials
 * the same way (every device fails as credentials_missing), so the dashboard checks the same thing before sending.
 */
export function platformsReady(app: AppDetail, env: Environment): Record<'android' | 'ios', boolean> {
  const e = app.environments.find((x) => x.environment === env);
  return { android: !!e?.android?.enabled, ios: !!e?.ios?.enabled };
}
